module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens3-d0b62a0212a06b0a08f5d4580730bdc9.jpg";